import { defineStore } from 'pinia';
import { ref } from "vue";
import axios from 'axios';

import { endpoint } from "../issues_utils.js";


export const useIssueStore = defineStore(
  'issues',
  () => {
    const park_list = ref([]);
    const staffers = ref([]);
    const agency_list = ref([]);
    const ticket_list = ref([]);
    const loading_data = ref(false);
    const displayed_tickets = ref([]);
    const parks_with_issues = ref([]);
    const agencies_with_issues = ref([]);
    const creators_with_issues = ref([]);

    async function load_staffers() {
      loading_data.value = true;
      try {
        const response = await axios.get(
          endpoint('internal/current/users/?is_staff=1&is_active=1'),
          { withCredentials: true });
        if (response.statusText === "OK") {
          staffers.value = response.data;
        }
      } catch (e) {
        alert(e.toString());
      } finally {
        loading_data.value = false;
      }
    }

    async function load_parks() {
      loading_data.value = true;
      try {
        const response = await axios.get(
          endpoint('internal/current/parks/'),
          { withCredentials: true });
        if (response.statusText === "OK") {
          park_list.value = response.data;
        }
      } catch (e) {
        alert(e.toString());
      } finally {
        loading_data.value = false;
      }
    }

    async function load_agencies() {
      loading_data.value = true;
      try {
        const response = await axios.get(
          endpoint('internal/current/agency/'),
          { withCredentials: true });
        if (response.statusText === "OK") {
          agency_list.value = response.data;
        }
      } catch (e) {
        alert(e.toString());
      } finally {
        loading_data.value = false;
      }
    }

    async function load_tickets() {
      loading_data.value = true;
      try {
        let next = true;
        const out = [];
        let url = endpoint('internal/current/tickets/');
        while (next) {
          const response = await axios.get(url, { withCredentials: true });
          if (response.statusText === "OK") {
            out.push(...response.data.results);
            url = response.data.next;
            if (url === null || url === undefined) {
              next = false;
            }
          } else {
            next = false;
            console.log(response);
          }
        }
        ticket_list.value = out;

        const parks_map = new Map();
        ticket_list.value.forEach(ticket => {
          const park = { ...ticket['park'] };
          if (park.agency === null) {
            park.agency = -1;
          }
          parks_map.set(park.id, park);
        });
        parks_with_issues.value = Array.from(parks_map.values());

        const agencies_ids = parks_with_issues.value.map(park => park['agency']);
        agencies_with_issues.value = agency_list.value.filter(agency => agencies_ids.includes(agency.id));
        agencies_with_issues.value.push({ id: -1, name: 'Not assigned' });

        ticket_list.value.forEach(ticket => {
          const agency_id = ticket['park']['agency'] === null ? -1 : ticket['park']['agency'];
          ticket['agency'] = agencies_with_issues.value.find(a => a.id === agency_id);
          ticket['is_open'] = false;
        });

        displayed_tickets.value = ticket_list.value.sort((ticket1, ticket2) => {
          if (ticket1['priority'] < ticket2['priority']) {
            return -1;
          }
          if (ticket1['priority'] > ticket2['priority']) {
            return 1;
          }
          if (ticket1.id > ticket2.id) {
            return -1;
          }
          if (ticket1.id < ticket2.id) {
            return 1;
          }
        });
        creators_with_issues.value = staffers.value.filter(s => ticket_list.value.map(t => t['made_by']).includes(s.id));
      } catch (e) {
        alert(e.toString());
      } finally {
        loading_data.value = false;
      }
    }

    async function load_data() {
      await Promise.all([load_parks(), load_staffers(), load_agencies()]);
      await load_tickets();
    }

    return {
      park_list, staffers, agency_list, ticket_list, loading_data,
      displayed_tickets, parks_with_issues, agencies_with_issues, creators_with_issues,
      load_tickets, load_parks, load_data
    };
  }
);
